import { Card, Grid } from "@mui/material";
import FolderTree from "./FolderTree";
import LibraryContent from "./LibraryContent";

const TREE_PANEL_MAX_HEIGHT = 520;
const CONTENT_MIN_HEIGHT = 320;

/** Two-pane workspace: the folder tree on the left, the active content pane on the right. */
const LibraryWorkspace = ({ folderTree, content }) => (
  <Grid container spacing={2}>
    <Grid item xs={12} md={4}>
      <Card variant="outlined" sx={{ p: 1, maxHeight: TREE_PANEL_MAX_HEIGHT, overflow: "auto" }}>
        <FolderTree {...folderTree} />
      </Card>
    </Grid>
    <Grid item xs={12} md={8}>
      <Card variant="outlined" sx={{ p: 1, minHeight: CONTENT_MIN_HEIGHT }}>
        <LibraryContent {...content} />
      </Card>
    </Grid>
  </Grid>
);

export default LibraryWorkspace;
